import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loopringlogo",
  "use": "loopringlogo-usage",
  "viewBox": "0 0 30 23.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 23.9\" id=\"loopringlogo\"><title>loopring-lrc-logo</title><path id=\"loopringlogo_Path\" d=\"M17.4,11.6H30v.1l-19.7,12,9.8-7.8ZM10,0V23.9l-10-8Z\" style=\"fill:#1c60ff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol